<template>
  <base-form-group
    :is-invalid="isInvalid"
    :errors="errors"
    :messages="messages"
    :class="disabled ? '' : 'form-group-range'"
  >
    <div class="input-group-range">
      <label v-if="label" class="form-label">{{ label }}</label>
      <template v-if="disabled">
        <h6>{{ localStartValue }} — {{ localEndValue }}</h6>
      </template>
      <template v-else>
        <base-input
          type="text"
          :isNumber="true"
          name="hr-min"
          :value="localStartValue"
          :min-value="min"
          :max-value="max"
          @change="changeStartValue"
        ></base-input>
        —
        <base-input
          type="text"
          :isNumber="true"
          name="hr-max"
          :value="localEndValue"
          :min-value="min"
          :max-value="max"
          @change="changeEndValue"
        ></base-input>
      </template>
      <svg-icon
        v-if="!disabled"
        @click:icon="setInterval"
        :name="'interval-hr'"
        class="svg-icon-middle ml-3"
      ></svg-icon>
    </div>
    <div v-if="!disabled" class="form-range" :data-min="min" :data-max="max">
      <range-slider
        :start="startValuesArray"
        :min="min"
        :max="max"
        :step="step"
        :colors="rangeColors"
        class="bg-start-yellow-warning bg-end-danger"
        @input="emitInputValuesBySlider"
      ></range-slider>
    </div>
    <slot></slot>
  </base-form-group>
</template>

<script>
export default {
  name: 'BaseRangeTwoInputs',
  components: {
    BaseFormGroup: () => import('@/base/BaseFormGroup.vue'),
    BaseInput: () => import('@/base/BaseInput.vue'),
    RangeSlider: () => import('@/plugins/RangeSlider.vue'),
    SvgIcon: () => import('@/components/SvgIcon.vue')
  },
  props: {
    label: {
      type: String,
      required: false
    },
    startValue: {
      type: Number,
      required: false
    },
    endValue: {
      type: Number,
      required: false
    },
    min: {
      type: Number,
      required: false
    },
    max: {
      type: Number,
      required: false
    },
    step: {
      type: Number,
      required: false,
      default: 1
    },
    isInvalid: {
      type: Boolean,
      required: false,
      default: false
    },
    errors: {
      type: Object,
      required: false
    },
    messages: {
      type: Object,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    localStartValue: null,
    localEndValue: null,
    rangeColors: ['bg-yellow-warning', 'bg-main', 'bg-danger'],
    startValuesArray: []
  }),
  created() {
    this.localStartValue = this.startValue
    this.localEndValue = this.endValue
    this.updateSliderStartValues()
  },
  watch: {
    startValue() {
      this.localStartValue = this.startValue
    },
    endValue() {
      this.localEndValue = this.endValue
    }
  },
  computed: {},
  methods: {
    changeStartValue(value) {
      this.localStartValue = Number(value)
      this.updateSliderStartValues()
      this.emitInputValues()
    },
    changeEndValue(value) {
      this.localEndValue = Number(value)
      this.updateSliderStartValues()
      this.emitInputValues()
    },
    updateSliderStartValues() {
      this.startValuesArray = [+this.localStartValue, +this.localEndValue]
    },
    emitInputValuesBySlider(values) {
      this.localStartValue = parseInt(values[0], 10)
      this.localEndValue = parseInt(values[1], 10)
      this.emitInputValues()
    },
    emitInputValues() {
      this.$emit('input', this.localStartValue, this.localEndValue)
    },
    setInterval() {
      this.$emit('set:interval')
    }
  }
}
</script>
